import { TIME_UNITS, DATA_UNITS } from '@belong/constants';

import { IMetric } from '@belong/types';

const getAriaUnit = ({
  measurementUnit,
  interval,
  priceUnit
}: Pick<IMetric, 'measurementUnit' | 'interval' | 'priceUnit'>): string => {
  if (measurementUnit) {
    return ` ${DATA_UNITS[measurementUnit]}${interval ? ` per ${interval.toLowerCase()}` : ''}`;
  }
  if (priceUnit) {
    return ` dollars${interval ? ` per ${interval.toLowerCase()}` : ''}`;
  }
  return '';
};

export const getAriaLabel = ({
  value,
  measurementUnit,
  interval,
  priceUnit
}: Pick<IMetric, 'value' | 'measurementUnit' | 'interval' | 'priceUnit'>): string =>
  `${value}${getAriaUnit({ measurementUnit, interval, priceUnit })}`;

export const getTimeUnitKey = (timeValue: string): string | undefined => {
  return Object.keys(TIME_UNITS).find(key => TIME_UNITS[key] === timeValue);
};
